import { useEffect, useRef } from "react";

import { ModalWrapper } from "./style";
interface ModalProps {
  children?: React.ReactNode;
  open: boolean;
  className?: string;
  close?: () => void;
}

function Modal({ open, close, className, children }: ModalProps) {
  const modalRef = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const closeModalWithEscKey = (e: KeyboardEvent) => {
      if (close && e.key === "Escape") {
        close();
      }
    };
    const closeModalOnClickOutside = (e: MouseEvent) => {
      if (
        close &&
        modalRef.current &&
        !modalRef.current.contains(e.target as Node)
      ) {
        close();
      }
    };
    if (open) {
      window.addEventListener("keyup", closeModalWithEscKey);
      document.addEventListener("mousedown", closeModalOnClickOutside);
    } else {
      window.removeEventListener("keyup", closeModalWithEscKey);
      document.removeEventListener("mousedown", closeModalOnClickOutside);
    }
    return () => {
      window.removeEventListener("keyup", closeModalWithEscKey);
      document.removeEventListener("mousedown", closeModalOnClickOutside);
    };
  }, [open, close]);

  return (
    <>
      {open && (
        <ModalWrapper ref={modalRef} tabIndex={-1} className={className}>
          {children}
        </ModalWrapper>
      )}
    </>
  );
}
export default Modal;
